import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Entities, InsertActionData } from '../../data-rules-model';
import { DataRulesService } from '../../data-rules.service';
import { AutocompleteComponent } from '../../lib/autocomplete/autocomplete.component';
import { ProviderFactory } from '../../lib/provider-factory';
import { MetaDataService } from '../../meta-data.service';
import { IrreversibleActionWarningBlockComponent } from '../action-warning-block/irreversible-action-warning-block.component';

@Component({
  selector: 'app-action-insert',
  templateUrl: './insert-action.component.html',
  imports: [
    ReactiveFormsModule,
    AutocompleteComponent,
    IrreversibleActionWarningBlockComponent
  ],
  styleUrls: ['../action.component.scss']
})
export class InsertActionComponent implements OnInit {
  @Input() actionData: InsertActionData;
  @Input() actionForm: FormGroup;
  @Input() primaryEntity: Entities;
  // todo wrap placeholder correctly for loading processes
  toManyPlaceholderText: string;
  warningMessage = 'Using INSERT is irreversible and will not produce sample output. Are you sure you want to proceed?';

  entitySourceTypeControl: FormControl;
  entityDestinationTypeControl: FormControl;
  sourceIdControl: FormControl;

  @ViewChild('sourceId')
  set sourceId(v: AutocompleteComponent) {
    setTimeout(() => this.setSourceIdPickerComponent(v), 0);
  }
  private sourceIdPickerComponent: AutocompleteComponent;

  constructor(
    protected metaDataService: MetaDataService,
    private providerFactory: ProviderFactory,
    public dataRulesService: DataRulesService) {
  }

  ngOnInit(): void {
    this.createControls();

    this.subscribeToChanges();
  }

  createControls(): void {
    this.actionForm.removeControl('type');
    this.actionForm.removeControl('entitySourceType');
    this.actionForm.removeControl('entityDestinationType');
    this.actionForm.removeControl('sourceId');
    this.actionForm.removeControl('destinationType');

    this.entitySourceTypeControl = new FormControl(this.actionData.value.entitySourceType);
    this.entityDestinationTypeControl = new FormControl(this.actionData.value.entityDestinationType);
    this.sourceIdControl = new FormControl(this.actionData.value.sourceId, Validators.required);

    this.actionForm.addControl('type', new FormControl(this.actionData.type));
    this.actionForm.addControl('entitySourceType', this.entitySourceTypeControl);
    this.actionForm.addControl('entityDestinationType', this.entityDestinationTypeControl);
    this.actionForm.addControl('sourceId', this.sourceIdControl);
    this.actionForm.addControl('destinationType', new FormControl(this.actionData.destinationType));

  }

  get entityDestinationName(): string {
    const value = this.entityDestinationTypeControl.value;
    const isValueHardcoded = value && value.split('.').length > 0;
    return isValueHardcoded ? value.split('.')[value.split('.').length - 1] : value ? value : 'Unknown';
  }

  subscribeToChanges(): void {
  }

  private setSourceIdPickerComponent(acComponent: AutocompleteComponent): void {
    this.sourceIdPickerComponent = acComponent;
    this.toManyPlaceholderText = 'Loading...';
    this.sourceIdControl.disable();
    this.providerFactory.getCertificationsProvider(this.sourceIdControl.value).subscribe(provider => {
      this.sourceIdPickerComponent.setOptionsProvider(provider, this.sourceIdControl.value);
      this.toManyPlaceholderText = undefined;
      this.sourceIdControl.enable();
    });
  }
}
